const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://moshaquitos.dvgeo.app' : 'http://192.168.100.106:3067',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://moshaquitos.dvgeo.app' : 'http://192.168.100.106:3067',
    api: 'api/',
    apiSocket: 'moshaquitos::1.2',
    nameDir: 'moshaquitos',
    package: 'app.dvgeo.moshaquitos.web',
    version: '1.0.2',
    googleAPIKey: 'AIzaSyBqnA_17r-ltOB1B2Aj0DB_V32rXW5-hF0',
    appName: 'MOSHAQUITOS GO',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#0edb5a',
    colorDark: '#0edb5a',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.moshaquitos.passenger',
    playStoreDriverId: 'app.dvgeo.moshaquitos.driver',
    appStorePassengerId: '6756029302',
    appStoreDriverId: '6756025880',
};
export default config;
